/**
 * @generated SignedSource<<4d9d3e8ba901bd78e14ba658ce3d0c14>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CancelOrderInput = {
  id: string;
};
export type CancelOrderMutation$variables = {
  input?: CancelOrderInput | null | undefined;
};
export type CancelOrderMutation$data = {
  readonly cancelOrder: {
    readonly id: string;
  } | null | undefined;
};
export type CancelOrderMutation = {
  response: CancelOrderMutation$data;
  variables: CancelOrderMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Order",
    "kind": "LinkedField",
    "name": "cancelOrder",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CancelOrderMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CancelOrderMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ed79fe70b0e8a519aaa008db2f518d17",
    "id": null,
    "metadata": {},
    "name": "CancelOrderMutation",
    "operationKind": "mutation",
    "text": "mutation CancelOrderMutation(\n  $input: CancelOrderInput\n) {\n  cancelOrder(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "b4126d06531c1d4b9d7c5933a33bc1a7";

export default node;
